export function isNplDashboardHost() {
  if (typeof window === "undefined") return false;
  const host = String(window.location.hostname || "").toLowerCase();
  return (
    host === "npl.roadsense.tech" ||
    host.startsWith("npl.") ||
    host === "localhost" ||
    host === "127.0.0.1"
  );
}

export const NPL_GUEST_AUTH = {
  isLoggedIn: true,
  token: "npl-gcp",
  roles: "user",
};

const devices = (...ids) => ids.map((deviceId) => ({ deviceId }));

/** Public occupancy view — same lots as the Pi LEDs. Login stays on other tenants. */
export const NPL_GUEST_CONFIG = {
  name: "הפארק הלאומי רמת-גן",
  logo: null,
  token: "npl-gcp",
  areas: [
    { area: "AHAD_HA'AM", devices: devices("600a0c2a69e8a8fc", "600a0c2a69e8a8fa") },
    {
      area: "SAN_MARTIN",
      devices: devices(
        "600a0c2a69e8a8fe",
        "600a0c2a69e89a80",
        "600a0c2a69e8a8f8",
        "600a0c2a69e8829a"
      ),
    },
    { area: "ZVI", devices: devices("600a0c2a69e8a902", "600a0c2a69e8a900") },
    { area: "BERNSTEIN", devices: devices("600a0c2a69e8a908", "600a0c2a69e8a904") },
    {
      area: "CENTER_OF_THE_PARK",
      devices: devices(
        "600a0c2a69e83904",
        "600a0c2a69e9014c",
        "600a0c2a69e838f8",
        "600a0c2a69e838fa"
      ),
    },
    { area: "SHAKH", devices: devices("600a0c2a69e84c0a", "600a0c2a69e838fe") },
    { area: "CHEN", devices: devices("600a0c2a69e87fe6", "600a0c2a69e808f0") },
  ],
  map: {
    // Public Mapbox token (pk.). Restrict it in Mapbox to npl.roadsense.tech + localhost.
    mapboxToken:
      process.env.REACT_APP_MAPBOX_TOKEN ||
      "pk.eyJ1IjoiYXZpLXJvYWRzZW5zZSIsImEiOiJjbXQxa3gzZWkwZGhhMndzZ2lvZWM0ZWltIn0.D7im2yARxA_sHGa--8pg2A",
  },
  pages: {
    home: { show: false, components: {} },
    statistics: {
      show: true,
      components: {
        nationalParkContainer: true,
      },
    },
  },
};
